import { IFormSettings } from '@llws/lift-entity-interfaces';
import { Not, In, IQueryCommandOptions } from '@llws/dynamic-router-utils';
import { StoreBaseImplementation } from '@/shared/classes/store-base-implementation';
import { INewTranslationSettingsStoreConfig } from '@/shared/interfaces/new-translation-settings';
import { StoreBaseImplementationV2 } from '../../shared/classes/store-base-implementation-v2';

// Base store configuration
const adminGatewayResourcePath: string = '/website-api/sites/:param/form_settings';
const listViewName: string = '';
const showLogging: boolean = false;

const defaultGetListFilters: IQueryCommandOptions = {
  where: [{
    field: 'status',
    notOperator: true,
    value: 'deleted',
  }],
  limit: 9999,
};

const defaultGetSingleFilters = {};

const translationSettings: INewTranslationSettingsStoreConfig = {
  model: 'form_settings',
  keys: [
    'auto_response_body',
    'auto_response_subject',
    'error_msg',
    'follow_up_body',
    'follow_up_consent_text',
    'follow_up_subject',
    'mail_body',
    'mail_subject',
    'name',
    'success_msg',
    'title',
  ],
};

// Instantiate the base store with the params
const base = new StoreBaseImplementationV2<IFormSettings>({
  adminGatewayResourcePath,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
  translationSettings,
});

// Extend StoreBaseImplementation object to add custom state/getters/mutations/actions.
export default {
  namespaced: base.namespaced, // 'form-responses/'

  state: {
    ...base.state,
  },

  getters: {
    ...base.getters,
  },

  mutations: {
    ...base.mutations,
  },

  actions: {
    ...base.actions,
  },
};
